export default {
  apiKey: 'AIzaSyCUdTT9cc6J0bbu6pSRoxrLU5yEtehv91M',
  authDomain: 'freitagsprojekte.firebaseapp.com',
  databaseURL: 'https://freitagsprojekte.firebaseio.com',
  projectId: 'freitagsprojekte',
  storageBucket: 'freitagsprojekte.appspot.com',
  messagingSenderId: '534712866380',
  appId: '1:534712866380:web:8e45d0fd2a9ecf6abf86e9'
};
